import { Variants } from '../types/variant';

export const cardioVariants = {
  //slugs intervertis pour maintenir le lien envoyé
  cardiologie_bordeaux: {
    name: 'Cardiologie (Bordeaux)',
    status: 'restricted',
    description:
      'Questionnaire pour les patients de cardiologie. Couvre les motifs, les antécédents personnels et familiaux du patient ainsi que la prévention.',
    speciality: 'CARDIO-B',
    patientOnboarding: 'DEFAULT',
    patientOffboarding: 'DEFAULT',
    emailTemplate: 'MED_G_DEFAULT',
    reportTemplate: 'BASIC_SPECIALTY',
    initialQuestions: [],
    pages: {
      CONSULTATION: { title: 'Consultation', sections: ['CONTEXTE'] },
      COMPLAINTS: { title: 'Motifs', sections: ['MOTIF', 'SYMPTOMS'] },
      HISTORY: {
        title: 'Antécédents',
        sections: ['ANTECEDENTS'],
      },
      PREVENTION: {
        title: 'Prévention',
        sections: ['PREVENTION'],
      },
      CONCLUSION: { title: 'Conclusion', sections: ['RECAP'] },
    },
    initialAssertions: [
      "[Message: #‹]-(06.a_lieu_emission)->[Lieu]-(01.DESCR)->[Salle d'Attente]-(PART_OF)->[Cabinet Médical: #c]",
      '[Médecin: #z‹]-(a_spécialité)->[Cardiologie]',
    ],
    options: ['ALERTES'],
  },
  cardiologie: {
    name: 'Cardiologie',
    status: 'stable',
    availableInDemo: false,
    description:
      'Questionnaire pour les patients de cardiologie. Couvre les motifs, les antécédents personnels et familiaux du patient ainsi que la prévention.',
    speciality: 'CARDIO',
    patientOnboarding: 'DEFAULT',
    patientOffboarding: 'DEFAULT',
    emailTemplate: 'MED_G_DEFAULT',
    reportTemplate: 'CARDIOLOGY',
    visitMotivesSection: 'Motif de consultation',
    initialQuestions: [],
    pages: {
      CONSULTATION: { title: 'Consultation', sections: ['CONTEXTE'] },
      COMPLAINTS: {
        title: 'Motifs',
        sections: ['MOTIF', 'DEPUIS_CARDIO', 'SYMPTÔMES'],
      },
      HISTORY: {
        title: 'Antécédents',
        sections: [
          'MENSURATIONS',
          'ANTÉCÉDENTS PERSONNELS',
          'ANTÉCÉDENTS FEMME',
          'ANTÉCÉDENTS FAMILIAUX',
        ],
      },
      PREVENTION: {
        title: 'Prévention',
        sections: ['TABAC', 'ALCOOL', 'ACTIVITE_PHYSIQUE', 'ALIMENTATION'],
      },
      CONCLUSION: { title: 'Conclusion', sections: ['RECAP'] },
    },

    initialAssertions: [
      "[Message: #‹]-(06.a_lieu_emission)->[Lieu]-(01.DESCR)->[Salle d'Attente]-(PART_OF)->[Cabinet Médical: #c]",
      '[Médecin: #z‹]-(a_spécialité)->[Cardiologie]',
    ],
    options: ['ALERTES'],
    personalizableOptions: {
      MOTIVES_ENABLED_NEW_PATIENT: { default: true, duration: 3 },
      MOTIVES_ENABLED_EXISTING_PATIENT: { default: true, duration: 3 },
      MOTIVES_FREE_TEXT_NEW_PATIENT: { default: false, duration: 1 },
      MOTIVES_FREE_TEXT_EXISTING_PATIENT: { default: false, duration: 1 },
      MEDICAL_HISTORY_ENABLED_NEW_PATIENT: { default: true, duration: 1 },
      MEDICAL_HISTORY_ENABLED_EXISTING_PATIENT: { default: true, duration: 1 },
      PREVENTION_TOBACCO_ENABLED_NEW_PATIENT: { default: true, duration: 0.2 },
      PREVENTION_TOBACCO_ENABLED_EXISTING_PATIENT: {
        default: true,
        duration: 0.2,
      },
      PREVENTION_TOBACCO_REQUIRED_NEW_PATIENT: {
        default: false,
        duration: 0.75,
      },
      PREVENTION_TOBACCO_REQUIRED_EXISTING_PATIENT: {
        default: false,
        duration: 0.75,
      },
      PREVENTION_ALCOHOL_ENABLED_NEW_PATIENT: { default: true, duration: 0.2 },
      PREVENTION_ALCOHOL_ENABLED_EXISTING_PATIENT: {
        default: true,
        duration: 0.2,
      },
      PREVENTION_ALCOHOL_REQUIRED_NEW_PATIENT: {
        default: false,
        duration: 0.75,
      },
      PREVENTION_ALCOHOL_REQUIRED_EXISTING_PATIENT: {
        default: false,
        duration: 0.75,
      },
      PREVENTION_MENTAL_ENABLED_NEW_PATIENT: { default: true, duration: 0.2 },
      PREVENTION_MENTAL_ENABLED_EXISTING_PATIENT: {
        default: true,
        duration: 0.2,
      },
      PREVENTION_MENTAL_REQUIRED_NEW_PATIENT: {
        default: false,
        duration: 0.75,
      },
      PREVENTION_MENTAL_REQUIRED_EXISTING_PATIENT: {
        default: false,
        duration: 0.75,
      },
      PREVENTION_SLEEP_ENABLED_NEW_PATIENT: { default: true, duration: 0.2 },
      PREVENTION_SLEEP_ENABLED_EXISTING_PATIENT: {
        default: true,
        duration: 0.2,
      },
      PREVENTION_SLEEP_REQUIRED_NEW_PATIENT: { default: false, duration: 0.75 },
      PREVENTION_SLEEP_REQUIRED_EXISTING_PATIENT: {
        default: false,
        duration: 0.75,
      },
      PREVENTION_VACCINES_ENABLED_NEW_PATIENT: { default: true, duration: 0.2 },
      PREVENTION_VACCINES_ENABLED_EXISTING_PATIENT: {
        default: true,
        duration: 0.2,
      },
      PREVENTION_VACCINES_REQUIRED_NEW_PATIENT: {
        default: false,
        duration: 0.75,
      },
      PREVENTION_VACCINES_REQUIRED_EXISTING_PATIENT: {
        default: false,
        duration: 0.75,
      },
      PREVENTION_ACTIVITY_ENABLED_NEW_PATIENT: { default: true, duration: 0.2 },
      PREVENTION_ACTIVITY_ENABLED_EXISTING_PATIENT: {
        default: true,
        duration: 0.2,
      },
      PREVENTION_ACTIVITY_REQUIRED_NEW_PATIENT: {
        default: false,
        duration: 0.75,
      },
      PREVENTION_ACTIVITY_REQUIRED_EXISTING_PATIENT: {
        default: false,
        duration: 0.75,
      },
      SCREENING_TRAUMA_ENABLED_NEW_PATIENT: { default: true, duration: 0.15 },
      SCREENING_TRAUMA_ENABLED_EXISTING_PATIENT: {
        default: true,
        duration: 0.15,
      },
      SCREENING_COLORECTAL_ENABLED_NEW_PATIENT: {
        default: true,
        duration: 0.15,
      },
      SCREENING_COLORECTAL_ENABLED_EXISTING_PATIENT: {
        default: true,
        duration: 0.15,
      },
      SCREENING_CERVICAL_HPV_ENABLED_NEW_PATIENT: {
        default: true,
        duration: 0.15,
      },
      SCREENING_CERVICAL_HPV_ENABLED_EXISTING_PATIENT: {
        default: true,
        duration: 0.15,
      },
      SCREENING_BREAST_ENABLED_NEW_PATIENT: { default: true, duration: 0.15 },
      SCREENING_BREAST_ENABLED_EXISTING_PATIENT: {
        default: true,
        duration: 0.15,
      },
      SCREENING_DENTAL_ENABLED_NEW_PATIENT: { default: true, duration: 0.15 },
      SCREENING_DENTAL_ENABLED_EXISTING_PATIENT: {
        default: true,
        duration: 0.15,
      },
      SCREENING_DERMATOLOGY_ENABLED_NEW_PATIENT: {
        default: true,
        duration: 0.15,
      },
      SCREENING_DERMATOLOGY_ENABLED_EXISTING_PATIENT: {
        default: true,
        duration: 0.15,
      },
      SCREENING_COPD_ENABLED_NEW_PATIENT: { default: true, duration: 0.15 },
      SCREENING_COPD_ENABLED_EXISTING_PATIENT: {
        default: true,
        duration: 0.15,
      },
    },
  },
} satisfies Variants;
